import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class FeedbackBody extends PrimitiveValueObject<string> {
  static create(value: string): FeedbackBody {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new FeedbackBody(value);
  }
}
